// Logica pura del version-guard: parseo y comparacion, sin tocar el DOM.
//
// Vive aparte para poder testearla en el runner de node del repo (mismo
// criterio que admin-portal/src/lib/charts). Es donde estan los errores
// silenciosos: una regex que no matchea deja al cliente ciego sin fallar.

/** Lee un <meta name="authsys-{name}"> de un HTML crudo. */
export function metaFrom(html: string, name: string): string | null {
  const re = new RegExp(
    `<meta[^>]+name=["']authsys-${name}["'][^>]+content=["']([^"']*)["']`,
    'i',
  );
  const m = re.exec(html);
  return m?.[1] && m[1].length > 0 ? m[1] : null;
}

/**
 * Huella de los assets que referencia un HTML.
 *
 * Vite emite los nombres con hash de contenido, asi que la lista ordenada de
 * assets ya es una identidad del bundle. Es la ultima red: sirve aunque el
 * HTML no tenga ningun meta nuestro.
 */
export function fingerprintFrom(html: string): string {
  const urls: string[] = [];
  const re = /<(?:script[^>]+src|link[^>]+href)=["']([^"']+)["']/gi;
  let m: RegExpExecArray | null;
  while ((m = re.exec(html)) !== null) {
    const url = m[1];
    if (url && url.includes('/assets/')) urls.push(url);
  }
  return urls.sort().join('|');
}

/** djb2 — no necesita ser criptografico, solo estable y corto. */
export function shortHash(input: string): string {
  let h = 5381;
  for (let i = 0; i < input.length; i += 1) {
    h = ((h << 5) + h + input.charCodeAt(i)) >>> 0;
  }
  return h.toString(36);
}

/**
 * Estoy por debajo del minimo exigido?
 *
 * No hay orden entre hashes de contenido, asi que "mas viejo que X" no es una
 * pregunta respondible. La unica que si: soy exactamente el minimo, o soy la
 * version publicada? Si no soy ninguno de los dos, estoy atras.
 */
export function belowMinimum(
  localBuildId: string,
  publishedBuildId: string,
  minBuildId: string | null,
): boolean {
  if (!minBuildId) return false;
  return localBuildId !== minBuildId && localBuildId !== publishedBuildId;
}
